module.exports = __webpack_public_path__ + "img/img13.62b2fa9b.jpg";